import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const LeaderboardIcon: LucideIcon = forwardRef(({ size = 24, color = 'currentColor', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M7.87868 18.1817H12.1213V10.909H7.87868V18.1817ZM13.9394 19.0908C13.9394 19.5928 13.5323 19.9997 13.0304 19.9999H6.96961C6.46755 19.9999 6.06055 19.5929 6.06055 19.0908V10.6063C6.06055 9.76941 6.73921 9.09082 7.57595 9.09082H12.424C13.2608 9.09082 13.9394 9.76944 13.9394 10.6063V19.0908Z'
        fill={color}
      />
      <path
        d='M13.9392 18.1821H18.1818V16.4651H13.9392V18.1821ZM20 18.4857C19.9998 19.3224 19.3212 20.0003 18.4846 20.0003H13.0302C12.5281 20.0003 12.1211 19.5933 12.1211 19.0912V16.1624C12.1211 15.3256 12.7997 14.647 13.6365 14.647H18.4846C19.3214 14.647 20 15.3256 20 16.1624V18.4857Z'
        fill={color}
      />
      <path
        d='M1.81813 18.1817H6.06074V14.4442H1.81813V18.1817ZM7.87887 19.0908C7.87877 19.5927 7.47167 19.9997 6.96981 19.9999H1.51541C0.73108 19.9999 0.085744 19.4037 0.00798984 18.6398L0 18.4844V14.1414C0 13.3046 0.678664 12.626 1.51541 12.626H6.36347L6.51794 12.634C7.28212 12.7114 7.87887 13.3567 7.87887 14.1414V19.0908Z'
        fill={color}
      />
      <path
        d='M8.93313 0.623214C9.40101 -0.207795 10.5975 -0.207681 11.0655 0.623214L11.1099 0.708441L11.821 2.21767L13.3968 2.45915C14.4484 2.62001 14.7562 3.88569 14.0866 4.56852L12.9227 5.75371L13.1997 7.43871C13.3468 8.33596 12.4418 9.22192 11.4899 8.7837L11.3976 8.73665L9.99933 7.96694L8.602 8.73665C7.61722 9.27891 6.64805 8.365 6.79984 7.43871L7.07505 5.75371L5.91297 4.56852C5.24301 3.88552 5.55073 2.62007 6.60187 2.45915L8.17676 2.21767L8.88874 0.708441L8.93313 0.623214ZM9.61493 3.43127C9.48589 3.70488 9.2295 3.89688 8.93047 3.94263L7.98767 4.08645L8.6961 4.80911C8.89889 5.01583 8.99145 5.30724 8.94467 5.59302L8.78576 6.55892L9.56078 6.13279C9.83365 5.98259 10.165 5.98265 10.4379 6.13279L11.212 6.55892L11.0549 5.59302C11.0081 5.30721 11.0998 5.01585 11.3026 4.80911L12.011 4.08645L11.0682 3.94263C10.7693 3.89682 10.5127 3.70481 10.3837 3.43127L9.99933 2.61628L9.61493 3.43127Z'
        fill={color}
      />
    </svg>
  )
})

LeaderboardIcon.displayName = 'LeaderboardIcon'
